import React from "react";
import styled from "styled-components";
import GlobalSeo from "../templates/meta";
import Overlay from "../components/overlay";
import Feed from "../components/feed";

const Container = styled.div``;

export default class extends React.Component {
  state = {
    focusedProject: null
  };

  focusProject = project => {
    this.setState({
      focusedProject: project
    });
  };

  loseProjectFocus = project => {
    setTimeout(() => {
      if (
        this.state.focusedProject &&
        this.state.focusedProject.id === project.id
      ) {
        this.setState({
          focusedProject: null
        });
      }
    }, 200);
  };

  render() {
    const { allProject, globalSeo } = this.props.data;
    const { focusedProject } = this.state;

    const projects = allProject.edges.map(({ node }) => node);

    return (
      <Container>
        <GlobalSeo {...globalSeo} />
        <Feed
          projects={projects}
          onProjectFocus={this.focusProject}
          onProjectBlur={this.loseProjectFocus}
          focusedProject={this.state.focusedProject}
        />
        <Overlay
          elements={[
            ["RO"],
            [focusedProject ? focusedProject.title : "ARCHITECTEN"],
            ["&"],
            ["AD"]
          ]}
        />
      </Container>
    );
  }
}

export const pageQuery = graphql`
  query indexQuery {
    allProject {
      edges {
        node {
          id
          itemType
          updatedAt
          title
          blurb
          slug
          bannerImage {
            url
          }
        }
      }
    }
    globalSeo {
      en {
        siteName
        titleSuffix
        fallbackSeo {
          title
          description
          image {
            path
            width
            height
            format
            size
          }
        }
      }
      favicon {
        path
        width
        height
        format
        size
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js